import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";
import DashboardSidebarMain from "../dashsidebar";
import "../../../App.css";

function DashboardMain() {
  const [stats, setStats] = useState({
    totalRevenue: "₹18,45,200/-",
    totalOrders: "1,240",
    activeArtisans: "48",
    rating: "4.9"
  });

  const recentOrders = [
    {
      id: "#KS-9842",
      customer: "Ajay Kumar",
      date: "26 May 2026",
      status: "Confirmed",
      amount: "₹3,400/-"
    },
    {
      id: "#KS-9841",
      customer: "Devika Menon",
      date: "26 May 2026",
      status: "Dispatched",
      amount: "₹8,200/-"
    },
    {
      id: "#KS-9840",
      customer: "Rahul R.",
      date: "25 May 2026",
      status: "Confirmed",
      amount: "₹1,850/-"
    },
    {
      id: "#KS-9839",
      customer: "Meera Nair",
      date: "25 May 2026",
      status: "Pending",
      amount: "₹4,120/-"
    },
    {
      id: "#KS-9838",
      customer: "Thomas George",
      date: "24 May 2026",
      status: "Confirmed",
      amount: "₹12,500/-"
    }
  ];

  const categories = [
    {
      name: "Spices & Aromatics",
      percentage: 42,
      color: "#123524",
      icon: "solar:leaf-bold"
    },
    {
      name: "Handlooms & Garments",
      percentage: 28,
      color: "#C5A880",
      icon: "solar:bill-list-bold"
    },
    {
      name: "Ayurveda & Wellness",
      percentage: 18,
      color: "#D4AF37",
      icon: "solar:heart-bold"
    },
    {
      name: "Savory & Crispy Snacks",
      percentage: 12,
      color: "#2D1F18",
      icon: "solar:cup-hot-bold"
    }
  ];

  return (
    <DashboardContainer>
      <DashboardSidebarMain />
      <MainPanel>
        {/* Header Row */}
        <HeaderRow>
          <div>
            <span className="subtitle">Operational Overview</span>
            <h2 className="title">Executive Insights Dashboard</h2>
          </div>
          <HeaderWidgets>
            <DateBadge>
              <Icon icon="solar:calendar-bold" />
              <span>Today: 26 May 2026</span>
            </DateBadge>
          </HeaderWidgets>
        </HeaderRow>

        {/* Stats Grid */}
        <StatsGrid>
          <StatCard>
            <div className="icon-wrapper green-accent">
              <Icon icon="solar:wallet-bold" />
            </div>
            <div className="stat-info">
              <span className="label">Total Sales Revenue</span>
              <h3 className="value">{stats.totalRevenue}</h3>
              <span className="trend positive">
                <Icon icon="solar:trending-up-bold" />
                <span>+12.4% vs last month</span>
              </span>
            </div>
          </StatCard>

          <StatCard>
            <div className="icon-wrapper gold-accent">
              <Icon icon="solar:bag-3-bold" />
            </div>
            <div className="stat-info">
              <span className="label">Total Orders Logged</span>
              <h3 className="value">{stats.totalOrders}</h3>
              <span className="trend positive">
                <Icon icon="solar:trending-up-bold" />
                <span>+8.2% vs last week</span>
              </span>
            </div>
          </StatCard>

          <StatCard>
            <div className="icon-wrapper bark-accent">
              <Icon icon="solar:shop-bold" />
            </div>
            <div className="stat-info">
              <span className="label">Active Artisan Sellers</span>
              <h3 className="value">{stats.activeArtisans}</h3>
              <span className="trend positive">
                <Icon icon="solar:trending-up-bold" />
                <span>+4 registered this month</span>
              </span>
            </div>
          </StatCard>

          <StatCard>
            <div className="icon-wrapper rating-accent">
              <Icon icon="solar:star-bold" />
            </div>
            <div className="stat-info">
              <span className="label">Artisan Rating Score</span>
              <h3 className="value">{stats.rating} / 5.0</h3>
              <span className="trend positive">
                <Icon icon="solar:check-circle-bold" />
                <span>142 reviews verified</span>
              </span>
            </div>
          </StatCard>
        </StatsGrid>

        {/* Executive Columns */}
        <DashboardGrid>
          {/* Left Panel – Recent Orders */}
          <PanelCard>
            <PanelHeader>
              <div className="title-block">
                <Icon icon="solar:receipt-bold" className="header-icon green" />
                <h4>Recent Transactions</h4>
              </div>
              <a href="/orders" className="panel-link">View All Orders</a>
            </PanelHeader>
            <TableContainer>
              <OrderTable>
                <thead>
                  <tr>
                    <th>Order Ref</th>
                    <th>Customer Name</th>
                    <th>Date Registered</th>
                    <th>Transaction Amount</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {recentOrders.map((order) => (
                    <tr key={order.id}>
                      <td><span className="order-id">{order.id}</span></td>
                      <td><span className="customer-name">{order.customer}</span></td>
                      <td><span className="date-text">{order.date}</span></td>
                      <td><span className="amount-text">{order.amount}</span></td>
                      <td>
                        <StatusBadge className={order.status.toLowerCase()}>
                          {order.status}
                        </StatusBadge>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </OrderTable>
            </TableContainer>
          </PanelCard>

          {/* Right Panel – Category progress trackers */}
          <PanelCard>
            <PanelHeader>
              <div className="title-block">
                <Icon icon="solar:pie-chart-3-bold" className="header-icon gold" />
                <h4>Category Sales</h4>
              </div>
            </PanelHeader>
            <CategoryList>
              {categories.map((cat, idx) => (
                <CategoryItem key={idx}>
                  <div className="cat-header">
                    <div className="cat-title">
                      <Icon icon={cat.icon} style={{ color: cat.color }} />
                      <span>{cat.name}</span>
                    </div>
                    <span className="percentage" style={{ color: cat.color }}>
                      {cat.percentage}%
                    </span>
                  </div>
                  <ProgressTrack>
                    <ProgressBar percentage={cat.percentage} color={cat.color} />
                  </ProgressTrack>
                </CategoryItem>
              ))}
            </CategoryList>

            {/* Quick Actions Panel */}
            <QuickActionsBox>
              <h5>Quick Admin Actions</h5>
              <ActionsGrid>
                <a href="/dash-product-add" className="action-btn">
                  <Icon icon="solar:add-circle-bold" />
                  <span>List New Product</span>
                </a>
                <a href="/dash-vendor-add" className="action-btn">
                  <Icon icon="solar:user-plus-bold" />
                  <span>Register Artisan</span>
                </a>
              </ActionsGrid>
            </QuickActionsBox>
          </PanelCard>
        </DashboardGrid>
      </MainPanel>
    </DashboardContainer>
  );
}

export default DashboardMain;

// Styled Components
const DashboardContainer = styled.div`
  display: flex;
  background: #FDFBF7;
  min-height: 100vh;
  font-family: "Jost", sans-serif;
`;

const MainPanel = styled.div`
  flex: 1;
  padding: 40px;
  background: #FDFBF7;
  overflow-x: hidden;

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  border-bottom: 1px solid rgba(197, 168, 128, 0.15);
  padding-bottom: 20px;

  .subtitle {
    font-size: 13px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    color: #c5a880;
  }

  .title {
    font-family: "Playfair Display", serif;
    font-size: 32px;
    font-weight: 700;
    color: #123524;
    margin: 5px 0 0;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
`;

const HeaderWidgets = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const DateBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(197, 168, 128, 0.12);
  border: 1px solid rgba(197, 168, 128, 0.25);
  color: #123524;
  border-radius: 50px;
  padding: 10px 18px;
  font-size: 13px;
  font-weight: 600;

  svg {
    font-size: 16px;
    color: #c5a880;
  }
`;

const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 30px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const StatCard = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
  background: #FFFFFF;
  border: 1px solid rgba(197, 168, 128, 0.15);
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(45, 31, 24, 0.02);
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 30px rgba(197, 168, 128, 0.1);
    border-color: #D4AF37;
  }

  .icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 12px;
    font-size: 24px;

    &.green-accent {
      background: rgba(18, 53, 36, 0.08);
      color: #123524;
    }
    &.gold-accent {
      background: rgba(212, 175, 55, 0.08);
      color: #D4AF37;
    }
    &.bark-accent {
      background: rgba(45, 31, 24, 0.08);
      color: #2D1F18;
    }
    &.rating-accent {
      background: rgba(197, 168, 128, 0.08);
      color: #C5A880;
    }
  }

  .stat-info {
    flex: 1;
    text-align: left;

    .label {
      display: block;
      font-size: 12px;
      color: #666;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      margin-bottom: 4px;
    }

    .value {
      font-size: 24px;
      font-weight: 700;
      color: #2D1F18;
      margin: 0;
    }

    .trend {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      font-size: 11px;
      margin-top: 6px;
      font-weight: 600;

      svg {
        font-size: 13px;
      }

      &.positive {
        color: #0f7c49;
      }
    }
  }
`;

const DashboardGrid = styled.div`
  display: grid;
  grid-template-columns: 2fr 1.2fr;
  gap: 24px;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
  }
`;

const PanelCard = styled.div`
  background: #FFFFFF;
  border: 1px solid rgba(197, 168, 128, 0.15);
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(45, 31, 24, 0.02);
  display: flex;
  flex-direction: column;
`;

const PanelHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  padding-bottom: 16px;

  .title-block {
    display: flex;
    align-items: center;
    gap: 10px;

    .header-icon {
      font-size: 22px;

      &.green {
        color: #123524;
      }
      &.gold {
        color: #C5A880;
      }
    }

    h4 {
      margin: 0;
      font-size: 18px;
      font-weight: 700;
      color: #2D1F18;
    }
  }

  .panel-link {
    font-size: 13px;
    font-weight: 600;
    color: #123524;
    text-decoration: none;
    transition: color 0.2s ease;

    &:hover {
      color: #C5A880;
    }
  }
`;

const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
`;

const OrderTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  font-size: 14px;

  thead {
    background: #FDFBF7;
    border-bottom: 1px solid rgba(197, 168, 128, 0.15);

    th {
      padding: 12px 16px;
      font-weight: 600;
      color: #123524;
      font-size: 12px;
      text-transform: uppercase;
      letter-spacing: 0.05em;
    }
  }

  tbody {
    tr {
      border-bottom: 1px solid rgba(0, 0, 0, 0.04);
      transition: background-color 0.2s ease;

      &:hover {
        background-color: rgba(242, 236, 225, 0.2);
      }

      &:last-child {
        border-bottom: none;
      }
    }

    td {
      padding: 14px 16px;
      vertical-align: middle;
      color: #2D1F18;
    }
  }

  .order-id {
    font-weight: 700;
    color: #123524;
  }

  .customer-name {
    font-weight: 500;
  }

  .date-text {
    font-size: 13px;
    color: #666;
  }

  .amount-text {
    font-weight: 600;
    color: #2D1F18;
  }
`;

const StatusBadge = styled.span`
  display: inline-block;
  padding: 4px 10px;
  border-radius: 50px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;

  &.confirmed {
    background: rgba(15, 124, 73, 0.08);
    color: #0f7c49;
    border: 1px solid rgba(15, 124, 73, 0.15);
  }

  &.dispatched {
    background: rgba(212, 175, 55, 0.08);
    color: #8c7623;
    border: 1px solid rgba(212, 175, 55, 0.15);
  }

  &.pending {
    background: rgba(220, 53, 69, 0.08);
    color: #dc3545;
    border: 1px solid rgba(220, 53, 69, 0.15);
  }
`;

const CategoryList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin-bottom: 24px;
`;

const CategoryItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  .cat-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .cat-title {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 14px;
      font-weight: 600;
      color: #2c3e50;

      svg {
        font-size: 16px;
      }
    }

    .percentage {
      font-weight: 700;
      font-size: 13px;
    }
  }
`;

const ProgressTrack = styled.div`
  width: 100%;
  height: 6px;
  background: #f1f3f5;
  border-radius: 10px;
  overflow: hidden;
`;

const ProgressBar = styled.div`
  height: 100%;
  width: ${props => props.percentage}%;
  background-color: ${props => props.color};
  border-radius: 10px;
  transition: width 0.8s ease-in-out;
`;

const QuickActionsBox = styled.div`
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  padding-top: 20px;
  margin-top: auto;
  text-align: left;

  h5 {
    font-size: 13px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #c5a880;
    margin: 0 0 12px;
  }
`;

const ActionsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;

  .action-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    background: #F2ECE1;
    border: 1px solid rgba(197, 168, 128, 0.15);
    color: #123524;
    text-decoration: none;
    border-radius: 8px;
    padding: 10px 14px;
    font-size: 12px;
    font-weight: 600;
    transition: all 0.2s ease;

    svg {
      font-size: 16px;
    }

    &:hover {
      background: #123524;
      color: #FDFBF7;
      border-color: #123524;
      transform: translateY(-1px);
    }
  }
`;
